export var VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
export var VAR_SCROLL_INDICATOR_COLOR = '--ds-menu-scroll-indicator-color';